import React from 'react'; 
import { RadioButton } from '@progress/kendo-react-inputs';
 
const CusRadioButton = (props) => {

    const{name, onChange, leftValue, rightValue,label, checkedValue, disabled} = props;
    const handleChange = React.useCallback(
        (e) => {
            props.onChange(e,name);
        },
        [onChange,checkedValue]
    )
    return (
        <div className="row around-xs inputPair elementVisible">
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
             <label className="box text-left">{label}</label>
         </div>
         <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div style={{width:'50%', float:'left'}}>
                <RadioButton id={name} name={name} value={leftValue} onChange={handleChange} checked={checkedValue === leftValue} disabled={disabled} >&nbsp;Yes</RadioButton>
            </div>
            <div style={{width:'50%', float:'left'}}>
                <RadioButton id={name} name={name} value={rightValue} onChange={handleChange} checked={checkedValue === rightValue} disabled={disabled} >&nbsp;No</RadioButton>
            </div>
         </div> 
        </div>  
    )
}

export default CusRadioButton;